import { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../components/ProtectedRoute/PrivateRoutes';
import booksMark from '../../assets/books.png';
import './Login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const { onLogin } = useAuth();

  const onFinish = async (values) => {
    setLoading(true);
    onLogin(values)
      .then((res) => {
        if (res?.status === 200) {
          messageApi.success('Ok');
        } else {
          messageApi.error(res?.response?.data || 'დაფიქსირდა შეცდომა');
        }
      })
      .catch((err) => {
        messageApi.error(err?.response?.data || 'დაფიქსირდა შეცდომა');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="login-page">
      {contextHolder}
      <div className="login-page__sky" aria-hidden="true" />
      <div className="login-page__horizon" aria-hidden="true" />

      <div className="login-page__composition">
        <header className="login-page__brand">
          <img
            className="login-page__mark"
            src={booksMark}
            alt=""
            width={72}
            height={72}
          />
          <h1 className="login-page__title">ელექტრონული ბიბლიოთეკა</h1>
          <p className="login-page__agency">
            სსიპ სამოქალაქო ავიაციის სააგენტო
          </p>
          <p className="login-page__lede">
            დოკუმენტებზე წვდომა ავტორიზებული მომხმარებლებისთვის
          </p>
        </header>

        <section className="login-page__panel" aria-labelledby="login-heading">
          <h2 id="login-heading" className="login-page__panel-title">
            სისტემაში შესვლა
          </h2>
          <Form
            className="login-page__form"
            name="login"
            onFinish={onFinish}
            layout="vertical"
            requiredMark={false}
            size="large"
          >
            <Form.Item
              label="მომხმარებელი"
              name="username"
              rules={[{ required: true, message: 'მომხმარებელი სავალდებულოა' }]}
            >
              <Input
                prefix={<UserOutlined style={{ color: '#0996c9' }} />}
                placeholder="შეიყვანეთ მომხმარებელი"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              label="პაროლი"
              name="password"
              rules={[{ required: true, message: 'პაროლი სავალდებულოა' }]}
            >
              <Input.Password
                prefix={<LockOutlined style={{ color: '#0996c9' }} />}
                placeholder="შეიყვანეთ პაროლი"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                className="login-page__submit"
                type="primary"
                htmlType="submit"
                loading={loading}
                block
              >
                შესვლა
              </Button>
            </Form.Item>
          </Form>
          <p className="login-page__footer">GCAA E-Library</p>
        </section>
      </div>
    </div>
  );
};

export default Login;
